import { InfoSet } from "../InfoSets/InfoSet";
import { ObjUtils, Iterable, IComparable } from "../Utils/ObjUtils";
import { HashSet } from "../Utils/HashSet";
import { IpAddress, IpVersion } from "../Core/IpAddress";
import { VendorNames } from "../InfoSets/ProductInfo";
import { Device } from "../Core/Device";
import { PhysicalNicTable } from "../Core/PhysicalNicTable";
import { VirtualNicTable } from "../Core/VirtualNicTable";
import { VirtualSwitchTable } from "../Core/VirtualSwitchTable";
import { VirtualPortGroupTable } from "../Core/VirtualPortGroupTable";
import { ObjectSerializer } from "../Serialization/ObjectSerializer";
import { ObjSerUtils } from "../Serialization/ObjSerUtils";
import { ValueEncoder } from "../Utils/ValueEncoder";

//export interface VirtualHostInfoJsonWrapper {
//    vhost_entry: VirtualHostInfoJson;
//}

//export interface VirtualHostInfoJson {
//    host_id: string;
//    uuid: string;
//    name: string;
//    description: string;
//    build: string;
//    host_os: string;
//    vendor: string;
//    model: string;
//    api_type: string;
//    api_version: string;
//    hw_model: string;
//    hw_vendor: string;
//    hw_cpu_model: string;
//    virtual_vendor: string;

//    physical_nic_table: any;
//    virtual_nic_table: any;
//    virtual_switch_table: any;
//    virtual_port_group_table: any;
//}

export class VirtualHostInfo extends InfoSet
{
    //public static FromJson(json: VirtualHostInfoJson, device: Device): VirtualHostInfo {
    //    var result = new VirtualHostInfo(device, json.host_id);

    //    if (json.uuid !== undefined)
    //        result.UUID = json.uuid;
    //    if (json.name !== undefined)
    //        result.Name = json.name;
    //    if (json.description !== undefined)
    //        result.Description = json.description;
    //    if (json.build !== undefined)
    //        result.Build = json.build;
    //    if (json.host_os !== undefined)
    //        result.HostOS = json.host_os;
    //    if (json.vendor !== undefined)
    //        result.Vendor = json.vendor;
    //    if (json.model !== undefined)
    //        result.Model = json.model;
    //    if (json.api_type !== undefined)
    //        result.ApiType = json.api_type;
    //    if (json.api_version !== undefined)
    //        result.ApiVersion = json.api_version;
    //    if (json.hw_model !== undefined)
    //        result.HwModel = json.hw_model;
    //    if (json.hw_vendor !== undefined)
    //        result.HwVendor = json.hw_vendor;
    //    if (json.hw_cpu_model !== undefined)
    //        result.HwCpuModel = json.hw_cpu_model;
    //    if (json.virtual_vendor !== undefined)
    //        result.VirtualVendor = json.virtual_vendor;

    //    // TODO:
    //    //physical_nic_table: any;
    //    //virtual_nic_table: any;
    //    //virtual_switch_table: any;
    //    //virtual_port_group_table: any;

    //    return result;
    //}

	public HostID: string;
	public get HasHostID():boolean {
		return !!this.HostID;
	}

	private _uuid: string;
	public get UUID():string {
		return this._uuid;
	}
	public set UUID(value:string) {
		this._uuid = value || '';
	}

	public get HasUUID(): boolean {
		return !!this.UUID;
	}

	private _name: string;
	public get Name(): string {
		return this._name;
	}
	public set Name(value: string) {
		this._name = value || '';
	}
	public get HasName(): boolean {
		return !!this._name;
	}

	private _description: string;
	public get Description(): string {
		return this._description;
	}
	public set Description(value: string) {
		this._description = value || '';
	}
	public get HasDescription(): boolean {
		return !!this._description;
	}

	private _build: string;
	public get Build(): string {
		return this._build;
	}
	public set Build(value: string) {
		this._build = value || '';
	}
	public get HasBuild(): boolean {
		return !!this._build;
	}

	private _hostOS: string;
	public get HostOS(): string {
		return this._hostOS;
	} 
	public set HostOS(value: string) {
		this._hostOS = value || '';
	}
	public get HasHostOS(): boolean {
		return !!this._hostOS;
	}

	private _vendor: string;
	public get Vendor(): string {
		return this._vendor;
	} 
	public set Vendor(value: string) {
		this._vendor = value || '';
	}
	public get HasVendor(): boolean {
		return !!this._vendor;
	}

	private _model: string;
	public get Model(): string {
		return this._model;
	} 
	public set Model(value: string) {
		this._model = value || '';
	}
	public get HasModel(): boolean {
		return !!this._model;
	}

	private _apiType: string;
	public get ApiType(): string {
		return this._apiType;
	}
	public set ApiType(value: string) {
		this._apiType = value || '';
	}
	public get HasApiType(): boolean {
		return !!this._apiType;
	}

	private _apiVersion: string;
	public get ApiVersion(): string {
		return this._apiVersion;
	} 
	public set ApiVersion(value: string) {
		this._apiVersion = value || '';
	}
	public get HasApiVersion(): boolean {
		return !!this._apiVersion;
	}

	// HARDWARE (HW) specific attributes
	private _hwModel: string;
	public get HwModel(): string {
		return this._hwModel;
	}
	public set HwModel(value: string) {
		this._hwModel = value || '';
	}
	public get HasHwModel(): boolean {
		return !!this._hwModel;
	}

	private _hwVendor: string;
	public get HwVendor(): string {
		return this._hwVendor;
	}
	public set HwVendor(value: string) {
		this._hwVendor = value || '';
	}
	public get HasHwVendor(): boolean {
		return !!this._hwVendor;
	}

	private _hwCpuModel:string;
	public get HwCpuModel(): string {
		return this._hwCpuModel;
	}
	public set HwCpuModel(value: string) {
		this._hwCpuModel = value || '';
	}
	public get HasHwCpuModel(): boolean {
		return !!this._hwCpuModel;
	}

	public VirtualVendor: string;
	public get HasVirtualVendor(): boolean {
		return !!this.VirtualVendor;
	}

	private ContainsKeyString(keyString: string): boolean {
		var index = -1;

		if (this.HasName) {
			index = this.Name.toLowerCase().indexOf(keyString.toLowerCase());
			if (index >= 0)
				return true;
		}

		if (this.HasDescription) {
			index = this.Description.toLowerCase().indexOf(keyString.toLowerCase());
			if (index >= 0)
				return true;
		}

		if (this.HasHostOS) {
			index = this.HostOS.toLowerCase().indexOf(keyString.toLowerCase());
			if (index >= 0)
				return true;
		}

		return false;
	}

	public get IsVMware(): boolean {

		if (this.HasVirtualVendor) {
			if (this.VirtualVendor == VendorNames.VMware)
				return true;
		}
		else {
			if (this.ContainsKeyString("vmware"))
				return true;
			if (this.ContainsKeyString(" esxi"))
				return true;
		}

		return false;
	}
	public get IsHyperV(): boolean {
		if (this.HasVirtualVendor) {
			if (this.VirtualVendor == VendorNames.Microsoft)
				return true;
		}
		else {
			if (this.ContainsKeyString("microsoft"))
				return true;
		}

		return false;
	}

	// Interfaces on the HOST (Physical / Virtual)
	public PhysicalNics: PhysicalNicTable;

	public VirtualNics: VirtualNicTable;

	// Virtual Switchs / Ports
	public VirtualSwitches: VirtualSwitchTable;

	public VirtualPortGroups: VirtualPortGroupTable;

	constructor(device?: Device, hostId?:string) {
		super(device);
		this.HostID = '';

		this.Init();
	}
		
	private Init():void {
		this._uuid = '';
		this._name = '';
		this._description = '';
		this._build = '';
		this._hostOS = '';
		this._vendor = '';
		this._model = '';

		this._apiType = '';
		this._apiVersion = '';

		this._hwModel = '';
		this._hwVendor = '';
		this._hwCpuModel = '';

		this.VirtualVendor = '';

		if (this.PhysicalNics == null)
			this.PhysicalNics = new PhysicalNicTable(this);
		else
			this.PhysicalNics.Clear();

		if (this.VirtualNics == null)
			this.VirtualNics = new VirtualNicTable(this);
		else
			this.VirtualNics.Clear();

		if (this.VirtualSwitches == null)
			this.VirtualSwitches = new VirtualSwitchTable(this);
		else
			this.VirtualSwitches.Clear();

		if (this.VirtualPortGroups == null)
			this.VirtualPortGroups = new VirtualPortGroupTable(this);
		else
			this.VirtualPortGroups.Clear();
	}

	public get IsVirtualCenterHost(): boolean {
		if (!!this._apiType) {
			if (this._apiType.toLowerCase() == "virtualcenter")
				return true;
		}

		if (this.ContainsKeyString("vcenter"))
			return true;

		return false;
	}

	public get IsVirtualSphereHost(): boolean {
		if (this.ContainsKeyString("vsphere"))
			return true;

		return false;
	}

	public get HasIpAddresses(): boolean {
		return true;
	}

	public get IpAddresses(): HashSet<IpAddress> {
		var ipAddresses = new HashSet<IpAddress>();

		if (this.PhysicalNics.Count > 0) {
			this.PhysicalNics.ForEach((pNic) => {
				if (!pNic.HasIpAddress)
					return;

				ipAddresses.Add(pNic.IpAddress);
			});
		}

		if (this.VirtualNics.Count > 0) {
			this.VirtualNics.ForEach((vNic) => {
				if (!vNic.HasIpAddress)
					return;

				ipAddresses.Add(vNic.IpAddress);
			});
		}

		return ipAddresses;
	}

	public Write(obj: any, context: any): void {
		obj.vh_info = {};
		obj = obj.vh_info;

		if (this.HasHostID)
			obj.host_id = this.HostID;

		if (this.HasUUID)
			obj.uuid = this.UUID;

		if (this.HasName)
			obj.name = this.Name;

		if (this.HasDescription)
			obj.description = this.Description;

		if (this.HasApiType)
			obj.api_type = this.ApiType;

		if (this.HasApiVersion)
			obj.api_version = this.ApiVersion;

		if (this.HasBuild)
			obj.build = this.Build;

		if (this.HasHostOS)
			obj.host_os = this.HostOS;

		if (this.HasVendor)
			obj.vendor = this.Vendor;

		if (this.HasModel)
			obj.model = this.Model;

		if (this.HasHwModel)
			obj.hw_model = this.HwModel;

		if (this.HasHwVendor)
			obj.hw_vendor = this.HwVendor;

		if (this.HasHwCpuModel)
			obj.hw_cpu_model = this.HwCpuModel;

		if (this.HasVirtualVendor)
			obj.virtual_vendor = this.VirtualVendor;

		this.PhysicalNics.Write(obj, context);
		this.VirtualNics.Write(obj, context);
		this.VirtualSwitches.Write(obj, context);
		this.VirtualPortGroups.Write(obj, context);
	}

	public Read(obj: any, context: any): void {
		if (!obj.vh_info)
			throw new Error();
		obj = obj.vh_info;

		if (obj.host_id !== undefined)
			this.HostID = obj.host_id;

		if (obj.uuid !== undefined)
			this.UUID = obj.uuid

		if (obj.name !== undefined)
			this.Name = obj.name;

		if (obj.description !== undefined)
			this.Description = obj.description;

		if (obj.api_type !== undefined)
			this.ApiType = obj.api_type;

		if (obj.api_version !== undefined)
			this.ApiVersion = obj.api_version;

		if (obj.build !== undefined)
			this.Build = obj.build;

		if (obj.host_os !== undefined)
			this.HostOS = obj.host_os;

		if (obj.vendor !== undefined)
			this.Vendor = obj.vendor;

		if (obj.model !== undefined)
			this.Model = obj.model;

		if (obj.hw_model !== undefined)
			this.HwModel = obj.hw_model;

		if (obj.hw_vendor !== undefined)
			this.HwVendor = obj.hw_vendor;

		if (obj.hw_cpu_model !== undefined)
			this.HwCpuModel = obj.hw_cpu_model;

		if (obj.virtual_vendor !== undefined)
			this.VirtualVendor = obj.virtual_vendor;

		if (obj.physical_nic_table !== undefined)
			this.PhysicalNics.Read(obj, context);

		if (obj.virtual_nic_table !== undefined)
			this.VirtualNics.Read(obj, context);

		if (obj.virtual_switch_table !== undefined)
			this.VirtualSwitches.Read(obj, context);

		if (obj.virtual_port_group_table !== undefined)
			this.VirtualPortGroups.Read(obj, context);
	}
}
